module.exports = __webpack_public_path__ + "img/notification-icon.d53268b9.png";